import { t } from 'i18next';
import { useContext, useMemo } from 'react';

import { CSVEntityImportAction } from '~components/CSVImportExport/CSVEntityImportAction';
import { FeatureFlags } from '~constants/featureFlags';
import { createTicketsConfig } from '~hooks/useCSVImportExport/configs/ticketsConfig';
import { Order } from '~hooks/useOrders/models';
import { useStores } from '~store';

import TicketsQueryContext from './tickets-table/TicketsQueryContext/TicketsQueryContext';

interface OrderTicketImportActionProps {
  order: Order;
}

export const OrderTicketImportAction = ({ order }: OrderTicketImportActionProps) => {
  const { userStore } = useStores();
  const userPermissions = userStore.getPermissions();
  const { refresh } = useContext(TicketsQueryContext);

  const ticketsImportConfig = useMemo(
    // The import endpoint matches tread_order_id against the human-readable order id
    // (e.g. ORD-3), not the UUID.
    () => createTicketsConfig({ tread_order_id: order.orderId }),
    [order.orderId],
  );

  return (
    <CSVEntityImportAction
      canCreateImportedEntity={userPermissions.canCreateImportedTicket}
      config={ticketsImportConfig}
      entityDisplayName={t('page_headings.tickets')}
      featureFlagKey={FeatureFlags.csvTicketImport}
      onImportComplete={refresh}
    />
  );
};
